module.exports = __webpack_public_path__ + "media/customizations/newfield/back-83bcb999e3f6cca4df1327cbb8971945.jpg";